import axios from 'axios';
import { api } from '../../../services/api';
import type { LandingContactFormValues } from '../validation/landing-contact';

export type SubmitContactRequestResponse = {
  received: boolean;
  sent?: boolean;
  mode?: string;
};

type ApiSuccess<T> = {
  success: true;
  data: T;
  timestamp: string;
};

/** POST /contact — sends the landing "contact sales" form to the team inbox. */
export async function submitContactRequest(
  values: LandingContactFormValues,
): Promise<SubmitContactRequestResponse> {
  const { data } = await api.post<ApiSuccess<SubmitContactRequestResponse>>(
    '/contact',
    {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      shelterName: values.shelterName,
      annualIntake: values.annualIntake,
      shelterSystem: values.shelterSystem,
      message: values.message ?? '',
      botField: values.botField ?? '',
    },
  );
  return data.data;
}

export function getContactRequestErrorMessage(err: unknown): string {
  if (axios.isAxiosError(err) && err.response?.data) {
    const d = err.response.data as {
      error?: { message?: string; details?: { message: string }[] };
    };
    if (d.error?.details?.length) {
      return d.error.details.map((x) => x.message).join(' ');
    }
    if (d.error?.message) return d.error.message;
  }
  if (err instanceof Error) return err.message;
  return 'Could not send your message. Please try again.';
}
